export default function ($routeSegmentProvider) {

  "ngInject";

  $routeSegmentProvider
    .when('/admin', 'admin')

    .segment('admin', {
      access: {requireLogin: true, hasAuthority: 'ADMIN'},
      template: '<admin-page></admin-page>',
      loadModule: () => {
        return import(/* webpackChunkName: "admin-root.module" */ "./admin-root.module");
      }
    });
}
